<template>
  <section class="prompts split">

    <a class="btn" href="#" @click.prevent="hide = !hide" v-if="!hideCollapseToggle">
      {{ hide ? `Expand Requests (${dedupedPrompts.length})` : "Collapse Requests" }}
    </a>

    <template v-if="!hide">
      <section :aria-label="`Request by ${prompt.username}`" class="prompt" v-for="(prompt, index) in dedupedPrompts"
        :key="index">
        <div class="user-data mb-2">
          <button aria-label="Toggle prompt bookmark" v-if="!isExchangeOpen" class="bookmark btn btn-link"
            @click="togglePromptmark(prompt)">
            <span v-if="hasPromptmark(prompt)" aria-label="Remove bookmark" class="fas fa-heart"></span>
            <span v-else class="far fa-heart" aria-label="Bookmark"></span>
          </button>

          <strong>
            <router-link :to="`/${exchangeId}/user/${prompt.username}`">{{
              prompt.username
              }}</router-link>
          </strong>
        </div>

        <div :class="[options.charsAsTags ? '' : 'flex']">
          <character-list v-if="(prompt.characters && prompt.characters.length) || (prompt.relationships &&
            prompt.relationships.length)" :characters="prompt.characters" :relationships="prompt.relationships"
            :tags="options.charsAsTags">
          </character-list>

          <div>
            <div>
              <div class="mb-2 " v-if="showFandom && prompt.fandom">
                <strong class="chip-title">Fandom:</strong>&nbsp;
                <span>{{ prompt.fandom }}</span>
              </div>

              <chips v-if="prompt.fandoms && prompt.fandoms.length > 1"
                :tags="prompt.fandoms.filter(f => f != prompt.fandom)" type="fandom" :exchangeId="exchangeId"
                title="Other Fandoms"></chips>
              <div class="mb-2" v-if="prompt.title">
                <strong class="chip-title">Title:</strong>&nbsp; <span>{{ prompt.title }}</span>
              </div>


              <chips :tags="prompt.warnings" title="Warnings"></chips>
              <chips :tags="prompt.ratings" title="Ratings"></chips>
              <chips :tags="prompt.freeforms" :truncate="$store.state.options.truncateTags"
                :limit="$store.state.options.tagLimit" title="Freeforms"></chips>
              <chips :tags="prompt.optionalTags || prompt.optional_tags" :truncate="$store.state.options.truncateTags"
                :limit="$store.state.options.tagLimit" title="Optional Tags"></chips>
            </div>
            <template v-if="prompt.prompt" class="mt-2">
              <div class="mb-2" v-if="prompt.letter && prompt.letter.length">
                <a :href="formatUrl(prompt.letter)" target="blank">Letter </a>

                <span class="tooltip c-hand" data-tooltip="If a request has HTML links in 
the optional details but no letter, 
the scraper interprets the last link
as a letter. Alas, this cannot be 
fixed due to the nature of AO3's
request page.">
                  <sup>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i> </sup></span>
              </div>
              <div v-if="showPrompt[index] == true ||
                !options.useToggles ||
                forceShow
              " v-html="prompt.prompt" class="prompt-text"></div>



              <button v-if="options.useToggles && !forceShow" class="btn btn-sm mt-2" @click="show(index)">
                {{ !showPrompt[index] ? "Read optional details" : "Show less" }}
              </button>
            </template>

            <p v-else-if="!prompt.prompt">
              No optional details given.
              <span v-if="prompt.letter">
                However, they do have a
                <a :href="formatUrl(prompt.letter)" target="blank">letter</a>.
              </span>
            </p>

            <div>
              <a class="btn btn-sm  mt-2" v-if="prompt.page && Number(prompt.page) > 0"
                :href="`https://archiveofourown.org/collections/${exchangeId}/requests?page=${prompt.page}&sort_column=created_at&sort_direction=ASC`"
                target="_blank">
                Approximate AO3 prompt page
              </a>
            </div>

          </div>
        </div>
        <div v-if="prompts && index < prompts.length - 1" class="divider" />
      </section>
    </template>
  </section>
</template>

<script>
import utils from "./utils.js";
import chips from "./chips.vue";
import characterList from "./character-list.vue";
import { mapGetters } from "vuex";
import { uniqWith } from "lodash-es"

export default {
  name: "splitview",
  components: { chips, characterList },
  computed: {
    ...mapGetters(["isExchangeOpen", "exchangeId", "options"]),
    dedupedPrompts() {
      if (!this.showFandom) return this.prompts;

      return uniqWith(this.prompts, (a, b) => {
        return a.request_id == b.request_id
      })
    }
  },
  props: {
    prompts: {
      type: Array,
      default() {
        return [];
      }
    },
    forceShow: {
      type: Boolean,
      default: false
    },
    hideCollapseToggle: {
      type: Boolean,
      default: false
    },
    showFandom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hide: false,
      showPrompt: {}
    };
  },
  created() {
    if (!this.prompts) {
      return;
    }
    this.prompts.forEach((element, i) => {
      this.showPrompt[i] = false;
    });

  },
  mounted() {
    if (this.options.openDetails) {
      utils.openDetails();
    }
  },
  updated() {
    if (this.options.openDetails) {
      utils.openDetails();
    }
  },
  methods: {
    ...utils,
    show(index) {
      let newShow = this.showPrompt;
      newShow[index] = !newShow[index];
      this.showPrompt = {};
      this.showPrompt = newShow;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.prompt {
  margin: 0.8em 0;
  // border-bottom: 1px solid $outline-light;

  &:last-child {
    .break {
      display: none;
    }
  }
}

.bookmark,
.letter {
  height: 1.3em;
}

.user-data {
  font-size: larger;

  .letter {
    padding: 0;
    margin: 0;
    vertical-align: baseline;
  }

  .bookmark {
    position: relative;
    bottom: 4px;
    margin-right: 0.4em;
  }
}

.flex {
  margin-top: 0.4em;
  display: flex;
}

ul {
  li {
    margin: 0;
    padding: 4px 0;
    border-bottom: 1px solid $outline-light;

    &:last-child {
      border: 0;
    }

    &:first-child {
      padding-top: 0;
    }
  }
}

.requested-characters {
  // margin-top: 1em;
  margin-right: 1em;
  flex: 0 0 25%;
}

.toggle {
  width: 150px;
  height: 35px;
  display: block;
}

.break {
  width: 80%;
  margin: 0.8em auto;
}

@media screen and (max-width: 767px) {
  .flex {
    display: inherit;
  }

  .requested-characters {
    display: block;
    margin-bottom: 0.5em;
  }
}
</style>

<style lang="scss">
.prompt-text,
.prompts .prompt-text {
  ul {
    list-style-type: disc;
  }

  p:first-child {
    margin-top: 0;
  }
}

.prompts.split {
  .prompt-text {
    p:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
